import React from 'react';
import { motion } from 'framer-motion';
const postres = [{
  clasico: 'Chocotorta de 5 minutos',
  fit: 'Bombones de avena y DDL'
}, {
  clasico: 'Flan casero con caramelo',
  fit: 'Mousse de palta y cacao'
}, {
  clasico: 'Alfajores de maicena',
  fit: 'Cookies de banana y avena'
}, {
  clasico: 'Pasta frola de membrillo',
  fit: 'Helado de banana fit'
}, {
  clasico: 'Mousse de chocolate',
  fit: 'Trufas de garbanzos'
}, {
  clasico: 'Panqueques con DDL',
  fit: 'Tarta de manzana fit'
}];
export const PostresSection = () => {
  return <section className="py-16 px-4 bg-black" data-id="element-191">
      <div className="max-w-4xl mx-auto" data-id="element-192">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-193">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4" data-id="element-194">
            🍮 ¿QUÉ AGREGA POSTRES RESUELTOS?
          </h2>
          <p className="text-xl text-gray-400 italic" data-id="element-195">
            Porque la cena no termina hasta el primer bocado dulce.
          </p>
        </motion.div>

        <div className="overflow-x-auto pb-4" data-id="element-196">
          <div className="min-w-[600px] w-full border border-orange-500/30 rounded-xl overflow-hidden" data-id="element-197">
            <div className="grid grid-cols-2 bg-gray-900 border-b border-orange-500/30" data-id="element-198">
              <div className="p-4 text-center font-bold text-white text-lg border-r border-orange-500/30" data-id="element-199">
                🍮 Clásicos (70%)
              </div>
              <div className="p-4 text-center font-bold text-orange-500 text-lg" data-id="element-200">
                🌿 Fit-Argento (30%)
              </div>
            </div>

            <div className="bg-black divide-y divide-gray-800" data-id="element-201">
              {postres.map((row, i) => <div key={i} className="grid grid-cols-2 hover:bg-gray-900/50 transition-colors" data-id="element-202">
                  <div className="p-4 text-gray-300 border-r border-gray-800 flex items-center justify-center text-center" data-id="element-203">
                    {row.clasico}
                  </div>
                  <div className="p-4 text-gray-300 flex items-center justify-center text-center" data-id="element-204">
                    {row.fit}
                  </div>
                </div>)}
            </div>
          </div>
        </div>
        <p className="text-center text-gray-500 text-sm mt-2 md:hidden" data-id="element-205">
          ← Deslizá para ver tabla completa →
        </p>
      </div>
    </section>;
};